import { Axios } from "index";

export const logItemSrnoDropdownApi = "/log-inventory/item-srno-dropdown";
export const logInwardSrnoDropdownApi = "/log-inventory/inward-srno-dropdown";

//Approval
export const fetchLogApprovalApi = `/approval/log-approval-invoice-listing`;
export const fetchLogItemsApprovalApi = function (id, invoice_id) {
  return `/approval/log-approval-item-listing-by-invoice/${id}/${invoice_id}`;
};
export const logApproveInvoiceApi = function (id, invoice_id) {
  return `/approval/log-approve_invoice_details/${id}/${invoice_id}`;
};
export const logRejectInvoiceApi = function (id, invoice_id) {
  return `/approval/log-reject_invoice_details/${id}/${invoice_id}`;
};

export const dropdownLogByOrderItemIdApi = async (_id) => {
  const res = await Axios.get(`/log-inventory/log-no-dropdown/${_id}`);
  return res;
};

export const listLogDetailsByLogItemIdApi = async (_id) => {
  const res = await Axios.get(`/log-inventory/list-log-details/${_id}`);
  return res;
};

export const issueRawLogOrderdApi = async (data) => {
  const res = await Axios.post(`/order/issue-raw-log-order/issue-order`, data);
  return res;
};

export const revertLogOrderApi = async (id) => {
  const res = await Axios.post(`/order/revert-order/${id}`);
  return res;
};

export const checkLogNoAlreadyExistApi = async (log_no, item_id) => {
  const res = await Axios.get(`/log-inventory/check_log_no_already_exist?log_no=${log_no}&item_id=${item_id}`);
  return res;
};
